export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5093.675d150a.jpg";